import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {common as stringsCommon, account as strings} from "strings";

import Button from "components/Button";
import Divider from "components/Divider";
import MobileNavigationHeader from "components/MobileNavigationHeader";
import PageTitle from "components/PageTitle";
import TextInput from "components/TextInput";

import {useUpdateUser} from "liberty-core/api/react-query/user";

import {useAlert} from "lib/alert";
import {useAuthenticatedUser} from "lib/auth";

import styles from "./AccountPage.module.css";

function PersonalInfoForm() {
  const [authenticatedUser, , setUserData] = useAuthenticatedUser();

  const [firstName, setFirstName] = useState(
    authenticatedUser?.data.firstName ?? "",
  );
  const [lastName, setLastName] = useState(
    authenticatedUser?.data.lastName ?? "",
  );
  const [email, setEmail] = useState(authenticatedUser?.data.email ?? "");

  const navigate = useNavigate();
  const alert = useAlert();
  const {mutateAsync: submitUserUpdateRequest} = useUpdateUser();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className={styles.personalInfoForm}>
      <div className={styles.inputFieldContainer}>
        <TextInput
          className={styles.inputField}
          label={stringsCommon.firstName}
          type="text"
          autoComplete="given-name"
          value={firstName}
          onChangeText={setFirstName}
        />
        <TextInput
          className={styles.inputField}
          label={stringsCommon.lastName}
          type="text"
          autoComplete="family-name"
          value={lastName}
          onChangeText={setLastName}
        />
        <TextInput
          className={styles.inputField}
          label={stringsCommon.email}
          type="email"
          autoComplete="email"
          value={email}
          onChangeText={setEmail}
        />
      </div>
      <div className={styles.saveButtonContainer}>
        <Button
          className={styles.saveButton}
          loading={isLoading}
          disabled={!firstName || !lastName || !email}
          onClick={(e) => {
            e.preventDefault();
            setIsLoading(true);
            submitUserUpdateRequest({firstName, lastName, email})
              .then(() => {
                setUserData({
                  firstName,
                  lastName,
                  name: `${firstName} ${lastName}`,
                  email,
                });
                navigate("/profile");
              })
              .catch((err) => {
                alert({
                  title: stringsCommon.whoops,
                  message:
                    err?.response?.data?.generic?.join("\n") ??
                    strings.genericErrorMessage,
                });
                setIsLoading(false);
              });
          }}
        >
          {strings.save}
        </Button>
      </div>
    </div>
  );
}

export default function AccountPage() {
  return (
    <div className={styles.container}>
      <MobileNavigationHeader backTo="/profile" />
      <PageTitle>{strings.title}</PageTitle>
      <Divider className={styles.divider} />
      <PersonalInfoForm />
    </div>
  );
}
